import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


import {
  Button
} from 'reactstrap';


import classNames from 'classnames';

import preventDefault from '../../utils/preventDefault';

import { FormSpy } from 'react-final-form';
import ShorbyLink from '../Links/ShorbyLink';

// Icons
import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faArrowRight from '@fortawesome/fontawesome-pro-light/faArrowRight';

import { currentProjectActiveDomainsSelector } from '../../reducers/selectors';
import shortUrl from '../helpers/ShortUrl';

const mapStateToProps = state => ({ domains: currentProjectActiveDomainsSelector(state), links: state.links });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch)
};

class BioLinkActionBar extends Component {
  
  render() {
    return <FormSpy subscription={{ values: true, submitting: true }} render={ ({values, form}) => {
      const { domains, links } = this.props;
      const formState = form.getState();
      const { dirty, submitting } = formState;
      //const slug = values.slug || values.unique_slug || '';
      //const url = link ? link.short_url : '';
      const url = shortUrl({...values, domains, links});
      
      const onClick = (e) => {
        preventDefault(e);
        return dirty ? form.submit() : window.open(url);
      }
      // <CustomSlugInputField values={values} />
      return (<div className="action-bar-container"><div className={classNames({"action-bar": true, dirty })}>
        <div className="s-logo"><span className="shor-logo">S</span></div>
        <div className="slug-input form-control"><ShorbyLink link={values} copyOnLinkClick={true} /></div>
        <Button color="primary" className={classNames({'loading': submitting})} onClick={onClick}>
          <FA icon={faArrowRight} />
          <span>{ submitting ? 'PUBLISHING' : 'PUBLISH' }</span>
        </Button>
      </div></div>
    )}} />
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(BioLinkActionBar);


// WEBPACK FOOTER //
// ./src/components/SmartPages/SmartPageActionBar.js